import { DEFAULT_PHONE_COUNTRY_CODE } from '@helpers/utils';
import { zodResolver } from '@hookform/resolvers/zod';
import { useTranslation } from 'react-i18next';
import { useForm } from 'react-hook-form';
import { TFunction } from 'i18next';
import { z } from 'zod';

const editEmployeesFormSchema = (t: TFunction) =>
  z.object({
    firstName: z
      .string()
      .min(3, t('FORMS.MIN_CHARACTERS', { limit: 3 }))
      .max(50, t('FORMS.MAX_CHARACTERS', { limit: 50 })),
    lastName: z
      .string()
      .min(3, t('FORMS.MIN_CHARACTERS', { limit: 3 }))
      .max(50, t('FORMS.MAX_CHARACTERS', { limit: 50 })),
    phoneNumber: z
      .string()
      .min(9, t('FORMS.MIN_CHARACTERS', { limit: '7' })) // min 9 because validator count also white spaces from mask
      .max(19, t('FORMS.MAX_CHARACTERS', { limit: 15 })), // 15 is max, we have 4 spaces in mask
    phoneExt: z.string().min(1, t('FORMS.REQUIRED')),
    email: z.string().email(t('FORMS.INVALID_EMAIL')).optional().or(z.literal('')),
    assignedVehicles: z.array(z.string()).optional(),
    labels: z.array(z.string()).optional(),
  });

const defaultEditEmployeesValues = {
  firstName: '',
  lastName: '',
  phoneNumber: '',
  phoneExt: DEFAULT_PHONE_COUNTRY_CODE,
  email: '',
  labels: [],
  assignedVehicles: [],
};

export type EditEmployeesForm = z.infer<ReturnType<typeof editEmployeesFormSchema>>;

export const useEditEmployeesDrawerForm = () => {
  const { t } = useTranslation();

  const form = useForm({
    resolver: zodResolver(editEmployeesFormSchema(t)),
    defaultValues: defaultEditEmployeesValues,
    mode: 'onBlur',
  });

  return { form };
};
